import { render, staticRenderFns } from "./RTree.vue?vue&type=template&id=663c39fb&scoped=true"
import script from "./RTree.vue?vue&type=script&lang=js"
export * from "./RTree.vue?vue&type=script&lang=js"
import style0 from "./RTree.vue?vue&type=style&index=0&id=663c39fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663c39fb",
  null
  
)

export default component.exports